module.exports = __webpack_public_path__ + "img/Dantam Hair 22.95089c4a.jpg";